import { connect } from 'react-redux';

import * as selectors from './dashboardSelectors';
import OngoingLoanView from './ongoingLoanView/OngoingLoanView';

import styles from './Dashboard.module.css';
import { SpillBanner } from '../../spill/SpillBanner';
import ApplyFlexiLoanInfoView from '../../applyFlexiLoanView/ApplyFlexiLoanInfoView/ApplyFlexiLoanInfoView';

const mapStateToProps = (state) => ({
    status: state.RLSDashboard.status
});

const Dashboard = ({ status }) => {
    return (
        <div className={styles.Dashboard}>
            {(() => {
                switch (status) {
                    case selectors.ONGOING_STATUS:
                        return (
                            <>
                                <div className={styles.bannerContainer}>
                                    <SpillBanner />
                                </div>
                                <OngoingLoanView />
                            </>
                        );
                    default:
                        return <ApplyFlexiLoanInfoView />;
                }
            })()}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(Dashboard);
